import { AxiosInstance } from "axios";
import authHeader from "./auth_header";
import axiosInstance from "./axios_instance";

interface ConfigValue {
  vehicleTypes: string[];
  vehicleWeights: number[];
  item: string;
  isCheckTotalWeight: boolean;
  isInputTotalLength: boolean;
  optionMixedLoading: boolean;
  requestNoteForDriver: string;
  requestNoteForAdmin: string;
  packagingType: string;
  loadingType: string;
  unloadingType: string;
}

const ApiPath = "/api/config";

export class Config {
  private instance: AxiosInstance;
  private readonly navigate: any;

  constructor(navigate: any) {
    this.instance = axiosInstance(navigate);
    this.navigate = navigate;
  }

  async inquiry(): Promise<ConfigValue> {
    const headers = authHeader(this.navigate);
    const response = await this.instance.get(ApiPath, { headers });

    const config = {
      vehicleTypes: [],
      vehicleWeights: [],
      item: "",
      optionMixedLoading: false,
      isCheckTotalWeight: false,
      isInputTotalLength: false,
      requestNoteForDriver: "",
      requestNoteForAdmin: "",
      packagingType: "",
      loadingType: "",
      unloadingType: "",
    };

    if (response?.data?.config?.vehicleTypes?.length !== 0) {
      //서버에서 받아온게 빈배열이 아닐경우 덮어 쓰기
      config.vehicleTypes = response.data.config.vehicleTypes;
    }
    if (response?.data?.config?.vehicleWeights?.length !== 0) {
      //서버에서 받아온게 빈배열이 아닐경우 덮어 쓰기
      config.vehicleWeights = response.data.config.vehicleWeights;
    }
    if (response?.data?.config?.item) {
      config.item = response.data.config.item;
    }
    if (response?.data?.config?.optionMixedLoading === true) {
      config.optionMixedLoading = true;
    }
    if (response?.data?.config?.requestNoteForDriver) {
      config.requestNoteForDriver = response.data.config.requestNoteForDriver;
    }
    if (response?.data?.config?.requestNoteForAdmin) {
      config.requestNoteForAdmin = response.data.config.requestNoteForAdmin;
    }
    if (response?.data?.config?.packagingType) {
      config.packagingType = response.data.config.packagingType;
    }
    if (response?.data?.config?.loadingType) {
      config.loadingType = response.data.config.loadingType;
    }
    if (response?.data?.config?.unloadingType) {
      config.unloadingType = response.data.config.unloadingType;
    }
    if (response?.data?.config?.isCheckTotalWeight) {
      config.isCheckTotalWeight = true;
    }
    if (response?.data?.config?.isInputTotalLength) {
      config.isInputTotalLength = true;
    }
    return config;
  }

  async modify(data: any) {
    const headers = authHeader(this.navigate);
    return await this.instance.put(ApiPath, data, { headers });
  }
}

export default Config;
